import React from "react"
import { useHistory } from "react-router-dom"
import SimpleHeader from "components/Headers/SimpleHeader.js"
import { Card, CardBody, Col, Container, Row } from "reactstrap"

const CARDS = [
  {
    key: "videos",
    path: "/admin/knowledge-videos",
    title: "Vídeo",
    description: "Vídeos do YouTube usados como base de conhecimento do SmartChat.",
    icon: "ni ni-collection",
  },
  {
    key: "documents",
    path: "/admin/knowledge-documents",
    title: "Documento",
    description: "PDFs, DOCX e PPTX usados como base de conhecimento do SmartChat.",
    icon: "ni ni-single-copy-04",
  },
]

export default function KnowledgeSourcesHome() {
  const history = useHistory()

  return (
    <>
      <SimpleHeader
        name="Base de Conhecimento"
        items={[{ level: "nav", name: "Base de Conhecimento do SmartChat" }]}
      />
      <Container className="mt--6" fluid>
        <Row className="justify-content-center">
          {CARDS.map(card => (
            <Col key={card.key} lg="3" md="5" xs="10" className="mb-4">
              <Card
                className="shadow text-center"
                style={{ cursor: "pointer", aspectRatio: "1 / 1" }}
                onClick={() => history.push(card.path)}
              >
                <CardBody className="d-flex flex-column align-items-center justify-content-center">
                  <i className={`${card.icon} text-info`} style={{ fontSize: "3rem" }} />
                  <h4 className="mt-3 mb-2">{card.title}</h4>
                  <p className="text-muted small mb-0">{card.description}</p>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </>
  )
}
